// @flow
import React, { useState } from 'react';
import classNames from 'classnames';
import { CardMetaInfo } from 'components/atoms/cardMetaInfo';
import { Image } from '../../atoms/image/index';
import RentalListCard from 'components/atoms/rentalListCard';
import styles from './styles.scss';

type Props = {
  data: Object,
  mediaPath?: string,
  onClick?: () => void,
  customClass?: string,
  vertical?: string,
};

export const CardView = (props: Props) => {
  const {
    data,
    onClick,
    type,
    height,
    background,
    customClass,
    containerClass,
    vertical,
  } = props;
  const [isDivHovered, divHovered] = useState(false);
  const containerClassName = classNames('card-container', containerClass);
  const imagePath =
    type === 'projects' ||
    type === 'architecture-projects' ||
    type === 'rentals'
      ? data.imagePath
      : type === 'products'
      ? isDivHovered
        ? data.detailCard.images.image_path +
          data.device.web +
          '/' +
          data.detailCard.images.hover_image
        : data.detailCard.images.image_path +
          data.device.web +
          '/' +
          data.detailCard.images.image
      : type === 'view-all-roles'
      ? data.listImageUrl
      : null;
  const thumbnailUrl =
    type === 'projects' || type === 'architecture-projects'
      ? data.thumbNailUrl
      : type === 'view-all-roles'
      ? data.thumbNailUrl
      : type === 'products'
      ? isDivHovered
        ? data.detailCard.images.image_path +
          data.device.thumbnail +
          '/' +
          data.detailCard.images.hover_image
        : data.detailCard.images.image_path +
          data.device.thumbnail +
          '/' +
          data.detailCard.images.image
      : null;

  return (
    <div className={containerClassName} onClick={onClick}>
      <div
        className={'card-img-section'}
        style={{ height: height, backgroundImage: background }}
      >
        <Image
          src={imagePath}
          alt={'image'}
          thumbNail={thumbnailUrl}
          onMouseLeave={() => divHovered(false)}
          onMouseEnter={() => divHovered(true)}
          isHoveredImagePresent={true}
        />
      </div>
      {type === 'rentals' ? (
        <RentalListCard data={data} />
      ) : (
        <CardMetaInfo
          className={customClass}
          data={data}
          type={type}
          vertical={vertical}
        />
      )}
    </div>
  );
};
